import { PayrollActionTypes } from './payroll.types'
import { API_CONSTANTS } from '../../utils/AppConstants'

const INITIAL_STATE = {
    newTaxRuleSuccess: null,
    newTaxRuleError: null,
    newTaxRuleReqStatus: '',
    taxRuleListSuccess: null,
    taxRuleListError: null,
    updateTaxRuleSuccess: null,
    updateTaxRuleError: null,
    updateTaxRuleReqStatus: '',
    provisionalPayslipSuccess: null,
    provisionalPayslipError: null,
    provisionalPayslipReqStatus: '',
    newPayslipSuccess: null,
    newPayslipError: null,
    newPayslipReqStatus: '',
    payslipListSuccess: null,
    payslipListError: null,
    payslipDetailSuccess: null,
    payslipDetailError: null,
    updatePayslipPaymentSuccess: null,
    updatePayslipPaymentError: null,
    updatePayslipPaymentReqStatus: ''
}

const payrollReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case PayrollActionTypes.NEW_TAX_RULE_REQUEST_SUCCESS:
            return {
                ...state,
                newTaxRuleSuccess: action.payload,
                newTaxRuleError: null,
                newTaxRuleReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case PayrollActionTypes.NEW_TAX_RULE_REQUEST_ERROR:
            return {
                ...state,
                newTaxRuleSuccess: null,
                newTaxRuleError: action.payload,
                newTaxRuleReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case PayrollActionTypes.NEW_TAX_RULE_REQUEST_STATUS:
            return {
                ...state,
                newTaxRuleReqStatus: ''
            }
        case PayrollActionTypes.TAX_RULE_LIST_REQUEST_SUCCESS:
            return {
                ...state,
                taxRuleListSuccess: action.payload,
                taxRuleListError: null
            }
        case PayrollActionTypes.TAX_RULE_LIST_REQUEST_ERROR:
            return {
                ...state,
                taxRuleListSuccess: null,
                taxRuleListError: action.payload
            }
        case PayrollActionTypes.UPDATE_TAX_RULE_REQUEST_SUCCESS:
            return {
                ...state,
                updateTaxRuleSuccess: action.payload,
                updateTaxRuleError: null,
                updateTaxRuleReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case PayrollActionTypes.UPDATE_TAX_RULE_REQUEST_ERROR:
            return {
                ...state,
                updateTaxRuleSuccess: null,
                updateTaxRuleError: action.payload,
                updateTaxRuleReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case PayrollActionTypes.UPDATE_TAX_RULE_REQUEST_STATUS:
            return {
                ...state,
                updateTaxRuleReqStatus: ''
            }
        case PayrollActionTypes.PROVISIONAL_PAYSLIP_REQUEST_SUCCESS:
            return {
                ...state,
                provisionalPayslipSuccess: action.payload,
                provisionalPayslipError: null,
                provisionalPayslipReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case PayrollActionTypes.PROVISIONAL_PAYSLIP_REQUEST_ERROR:
            return {
                ...state,
                provisionalPayslipSuccess: null,
                provisionalPayslipError: action.payload,
                provisionalPayslipReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case PayrollActionTypes.PROVISIONAL_PAYSLIP_REQUEST_STATUS:
            return {
                ...state,
                provisionalPayslipReqStatus: ''
            }
        case PayrollActionTypes.NEW_PAYSLIP_LIST_REQUEST_SUCCESS:
            return {
                ...state,
                newPayslipSuccess: action.payload,
                newPayslipError: null,
                newPayslipReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case PayrollActionTypes.NEW_PAYSLIP_LIST_REQUEST_ERROR:
            return {
                ...state,
                newPayslipSuccess: null,
                newPayslipError: action.payload,
                newPayslipReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case PayrollActionTypes.NEW_PAYSLIP_LIST_REQUEST_STATUS:
            return {
                ...state,
                newPayslipReqStatus: ''
            }
        case PayrollActionTypes.PAYSLIP_LIST_REQUEST_SUCCESS:
            return {
                ...state,
                payslipListSuccess: action.payload,
                payslipListError: null
            }
        case PayrollActionTypes.PAYSLIP_LIST_REQUEST_ERROR:
            return {
                ...state,
                payslipListSuccess: null,
                payslipListError: action.payload
            }
        case PayrollActionTypes.PAYSLIP_DETAIL_REQUEST_SUCCESS:
            return {
                ...state,
                payslipDetailSuccess: action.payload,
                payslipDetailError: null
            }
        case PayrollActionTypes.PAYSLIP_DETAIL_REQUEST_ERROR:
            return {
                ...state,
                payslipDetailSuccess: null,
                payslipDetailError: action.payload
            }
        case PayrollActionTypes.UPDATE_PAYSLIP_PAYMENT_STATUS_REQUEST_SUCCESS:
            return {
                ...state,
                updatePayslipPaymentSuccess: action.payload,
                updatePayslipPaymentError: null,
                updatePayslipPaymentReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case PayrollActionTypes.UPDATE_PAYSLIP_PAYMENT_STATUS_REQUEST_ERROR:
            return {
                ...state,
                updatePayslipPaymentSuccess: null,
                updatePayslipPaymentError: action.payload,
                updatePayslipPaymentReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case PayrollActionTypes.UPDATE_PAYSLIP_PAYMENT_STATUS_REQUEST_STATUS:
            return {
                ...state,
                updatePayslipPaymentReqStatus: ''
            }
        case PayrollActionTypes.LOGOUT:
            return INITIAL_STATE
        default:
            return state
    }
}

export default payrollReducer